module.exports = __webpack_public_path__ + "img/list.22ff2482.png";